import classNames from 'classnames';
import React from 'react';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import SVGIcon from '../SVGIcon';
import Tooltip from '../Tooltip';
import styles from './TextualControl.module.scss';

export interface TextualControlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  append?: React.ReactNode;
  error?: string;
  label?: React.ReactNode;
  prepend?: React.ReactNode;
  inlineError?: boolean;
}

const TextualControl = ({
  append,
  inlineError,
  error,
  label,
  prepend,
  ...inputProps
}: TextualControlProps) => (
  <label className={error && styles.error}>
    {!!label && <div className={styles.label}>{label}</div>}
    <div
      className={classNames(styles.inputContainer, {
        [styles.disabled]: inputProps.disabled,
      })}
    >
      {!!prepend && <div className={styles.prepend}>{prepend}</div>}
      <input {...inputProps} />
      {!!append && <div className={styles.append}>{append}</div>}
      {inlineError && error && (
        <div className={styles.errorContainer}>
          <Tooltip
            display="block"
            placement="top"
            popOverPortal={document.body}
            tooltip={error}
            trigger="hover"
            danger
            modifiers={[{ name: 'offset', options: { offset: [0, 9] } }]}
            enabledForSmallSize
          >
            <SVGIcon className={styles.errorIcon}>{alertIcon}</SVGIcon>
          </Tooltip>
        </div>
      )}
    </div>
  </label>
);

export default TextualControl;
